angular.module('study.ecrd.randomization')
    .config(['$stateProvider', 'RouteProvider', 'gettext', function($stateProvider, RouteProvider, gettext) {
        $stateProvider.state(RouteProvider.create('randomization', {
            url: '/randomization',
            component: 'randomizationMain',
            permission: 'access randomization',
            redirectTo: function(transition) {
                var AccountManager = transition.injector().get('AccountManager');

                return AccountManager.init()
                    .then(function() {
                        var stateName;

                        // redirigir a la primera sección para la que tengamos permisos
                        if (AccountManager.hasPermission('read randomization report')) {
                            stateName = 'randomization.log';
                        }
                        else if (AccountManager.hasPermission('access randomization stock')) {
                            stateName = 'randomization.stock';
                        }

                        if (stateName) {
                            return {
                                state: stateName,
                                params: transition.$to().params,
                            };
                        }
                    });
            },
        }));

        $stateProvider.state(RouteProvider.create('randomization.log', {
            url: '/log',
            component: 'randomizationLog',
            /// Lista de aleatorizaciones del estudio (log)
            htmlTitle: gettext('Registro de aleatorización'),
            permission: 'read randomization report',
            resolve: {
                sitesAvailable: ['ShareCrfSDK', function(ShareCrfSDK) {
                    return ShareCrfSDK.users.getAvailableSites();
                }],
            },
        }));

        $stateProvider.state(RouteProvider.create('randomization.blocks', {
            url: '/block',
            permission: 'read randomization blocks',
            redirectTo: 'randomization.blocks.list',
        }));

        $stateProvider.state(RouteProvider.create('randomization.blocks.list', {
            url: '',
            component: 'randomizationBlocks',
            htmlTitle: gettext('Estado de bloques de aleatorización'),
            permission: 'read randomization blocks',
            resolve: {},
        }));

        $stateProvider.state(RouteProvider.create('randomization.blocks.detail', {
            url: '/{blockId}',
            component: 'randomizationBlock',
            htmlTitle: gettext('Estado del bloque de aleatorización'),
            permission: 'read randomization blocks',
            resolve: {
                blockId: ['$transition$', function($transition$) {
                    return $transition$.params().blockId;
                }],
            },
        }));
    }]);
